import { render, staticRenderFns } from "./AppNavbarVerticalLayout.vue?vue&type=template&id=6fdab6d8&"
import script from "./AppNavbarVerticalLayout.vue?vue&type=script&lang=js&"
export * from "./AppNavbarVerticalLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fdab6d8')) {
      api.createRecord('6fdab6d8', component.options)
    } else {
      api.reload('6fdab6d8', component.options)
    }
    module.hot.accept("./AppNavbarVerticalLayout.vue?vue&type=template&id=6fdab6d8&", function () {
      api.rerender('6fdab6d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/components/app-navbar/AppNavbarVerticalLayout.vue"
export default component.exports